export default "__VITE_ASSET__tQ3l83RD__"